import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { SortOption } from '../../@types/Search';
import Panel from '../../StyledComponents/Panel';
import InputRadio from '../../StyledComponents/InputRadio';
import { RepeatSmall } from '../../StyledComponents/Repeat';
import { getTranslatedSortOptionDisplayName, hasSortOptionTranslation } from './Utils/SortOptions';

interface SortPanelProps {
  urlSearchParams?: URLSearchParams;
  loading?: boolean;
  sortOptions: SortOption[];
  onCloseFilter: () => void;
  onFilterUpdate: (query: string) => void;
}

const SortPanel = ({ loading, sortOptions, onCloseFilter, onFilterUpdate }: SortPanelProps) => {
  const _sortOptions = sortOptions
    ?.filter((x) => hasSortOptionTranslation(x.displayName))
    .map((x) => ({
      value: x.query,
      selected: x.selected,
      displayName: getTranslatedSortOptionDisplayName(x.displayName),
    }));

  const [selected, setSelected] = useState(_sortOptions?.find((x) => x.selected));

  useEffect(() => {
    if (!loading) {
      setSelected(undefined);
    }
  }, [loading]);

  return (
    <Panel title={i18next.t('search.sort')} onClose={onCloseFilter}>
      {_sortOptions.map((sort) => (
        <RepeatSmall key={sort.value}>
          <InputRadio
            id={`sort-${sort.value}`}
            name="sort"
            checked={
              selected?.value === sort.value ||
              _sortOptions.find((x) => x.value === sort.value)?.selected
            }
            value={sort.value}
            onChange={(e) => {
              setSelected({ ...sort, selected: !sort.selected });
              onFilterUpdate(e.currentTarget.value);
            }}
          >
            {sort.displayName}
          </InputRadio>
        </RepeatSmall>
      ))}
    </Panel>
  );
};

export default SortPanel;
